import type { IconProps } from "./types";

export function OcVideoIcon({
	className = "",
	size = 32,
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			className={className}
			viewBox="0 0 29 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Video</title>
			<path
				d="M2.41667 11C2.41667 7.70017 2.41667 6.05025 3.65537 5.02513C4.89405 4 6.88771 4 10.875 4H12.0833C16.0706 4 18.0642 4 19.303 5.02513C20.5417 6.05025 20.5417 7.70017 20.5417 11V13C20.5417 16.2998 20.5417 17.9497 19.303 18.9749C18.0642 20 16.0706 20 12.0833 20H10.875C6.88771 20 4.89405 20 3.65537 18.9749C2.41667 17.9497 2.41667 16.2998 2.41667 13V11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M20.5417 8.90585L20.6938 8.80196C23.2504 7.05623 24.5287 6.18336 25.556 6.60482C26.5833 7.02628 26.5833 8.42355 26.5833 11.2181V12.7819C26.5833 15.5765 26.5833 16.9737 25.556 17.3952C24.5287 17.8166 23.2504 16.9438 20.6938 15.198L20.5417 15.0941"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
}

export function OcCheckerboardIcon({
	className = "",
	size = 32,
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			className={className}
			viewBox="0 0 10 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Checkerboard</title>
			<path d="M2 0H0V2H2V0Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M2 4H0V6H2V4Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M2 8H0V10H2V8Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M4 2H2V4H4V2Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M4 6H2V8H4V6Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M6 0H4V2H6V0Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M6 4H4V6H6V4Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M6 8H4V10H6V8Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M10 0H8V2H10V0Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M10 4H8V6H10V4Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M10 8H8V10H10V8Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M8 2H6V4H8V2Z" fill="currentColor" fillOpacity="0.5" />
			<path d="M8 6H6V8H8V6Z" fill="currentColor" fillOpacity="0.5" />
		</svg>
	);
}

export function OcSlidersVerticalIcon({
	className = "",
	size = 32,
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			className={className}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Sliders Vertical</title>
			<path
				d="M17.5103 2.82471L17.5103 21.1753"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M6.48975 2.82471L6.48975 21.1753"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M17.51 6.00665C19.3023 6.00665 20.755 7.45952 20.7551 9.25177C20.7551 11.0441 19.3023 12.4969 17.51 12.4969C15.7178 12.4968 14.2649 11.044 14.2649 9.25177C14.265 7.45959 15.7178 6.00675 17.51 6.00665Z"
				fill="white"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
			<path
				d="M6.4895 11.702C8.28177 11.702 9.73452 13.1549 9.73462 14.9471C9.73462 16.7395 8.28183 18.1923 6.4895 18.1923C4.69726 18.1922 3.24438 16.7394 3.24438 14.9471C3.24448 13.155 4.69732 11.7021 6.4895 11.702Z"
				fill="white"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
		</svg>
	);
}

export function OcSocialIcon({
	className = "",
	size = 32,
}: IconProps) {
	return (
		<svg
			width={Math.round(size * (38 / 24))}
			height={size}
			className={className}
			viewBox="0 0 38 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Social media</title>
			<path
				d="M2.48387 19.5491C2.59868 20.0193 2.70552 20.4948 2.88633 20.9473C3.07775 21.4262 3.3026 21.8847 3.62924 22.2857C4.07098 22.8288 4.60789 23.2515 5.23598 23.5555C5.68696 23.7737 6.16008 23.9218 6.65912 23.9713C7.38674 24.0433 8.10648 23.9746 8.81911 23.8231C9.26378 23.729 9.70995 23.6432 10.1538 23.5442C13.3768 22.8256 16.6108 22.1577 19.8275 21.4093C20.2543 21.31 20.664 21.1654 21.0675 20.9964C21.8407 20.672 22.4777 20.171 22.9686 19.4917C23.5407 18.6999 23.8513 17.8163 23.8643 16.8288C23.8728 16.1834 23.7735 15.5521 23.6444 14.9251L23.6175 14.8002C23.6071 14.7518 21.3023 4.17237 21.2704 4.03285C21.1826 3.64961 21.0721 3.27439 20.9187 2.91194C20.7321 2.47022 20.512 2.04815 20.2027 1.67925C19.8758 1.28947 19.5002 0.956899 19.0665 0.689289C18.4023 0.279255 17.6869 0.042959 16.9055 0.00601943C16.1998 -0.0272952 15.5107 0.081762 14.8255 0.232175C14.8255 0.232175 14.8202 0.225824 14.8193 0.222467L4.44388 2.48973C4.44443 2.49334 4.44508 2.49692 4.44557 2.50041C4.05809 2.59258 3.66784 2.67478 3.29121 2.80762C2.87866 2.9533 2.47597 3.1249 2.10684 3.36167C1.5255 3.73496 1.05539 4.22125 0.691874 4.81275C0.280021 5.4829 0.0437631 6.20548 0.00614467 6.99499C-0.0274064 7.69941 0.080661 8.38675 0.227418 9.07065"
				fill="#FFFC00"
			/>
			<path
				d="M13.6114 19.3048C13.5673 19.3144 13.5251 19.3219 13.4928 19.3274C13.4681 19.3351 13.4422 19.3418 13.4159 19.3475C12.4927 19.5493 11.7805 19.2452 11.152 18.9766C10.7016 18.7845 10.2767 18.6031 9.82974 18.6251C9.61022 18.6362 9.39558 18.6642 9.19193 18.7088C8.82499 18.789 8.54737 18.9096 8.34465 18.9974C8.21989 19.0515 8.11229 19.098 8.02546 19.117C7.93452 19.1369 7.81965 19.1408 7.73944 18.9927C7.676 18.8759 7.62372 18.7608 7.57332 18.6499C7.44727 18.3729 7.36309 18.2054 7.25119 18.2123C6.05436 18.2855 5.31297 18.1704 5.10742 17.8796C5.08587 17.8491 5.07057 17.8169 5.06156 17.7837C5.03559 17.6893 5.08457 17.5908 5.17486 17.5548C6.06158 17.2015 6.77365 16.534 7.29135 15.5702C7.69246 14.824 7.82634 14.1656 7.84032 14.093C7.84092 14.0897 7.84168 14.0863 7.84254 14.0832C7.91725 13.7813 7.89293 13.5398 7.77055 13.3657C7.54489 13.0445 7.01665 12.9948 6.66718 12.9618C6.58028 12.9538 6.49807 12.946 6.43152 12.935C6.11682 12.8832 5.58763 12.7441 5.57858 12.3944C5.57194 12.1395 5.85711 11.8986 6.11734 11.8417C6.1896 11.826 6.25637 11.8247 6.31578 11.8384C6.63978 11.9127 6.9195 11.9251 7.14702 11.8754C7.42996 11.8136 7.54322 11.6754 7.56961 11.6373C7.52868 11.4873 7.48403 11.329 7.44161 11.1793L7.44097 11.1773C7.145 10.1293 6.7765 8.825 6.94898 7.99318C7.46522 5.50329 9.56183 4.86029 10.1919 4.7226C10.2087 4.71893 10.466 4.66002 10.466 4.66002C10.4776 4.65727 10.4902 4.65435 10.5033 4.65149C11.1351 4.51342 13.3124 4.22268 14.8103 6.27386C15.3107 6.95918 15.5137 8.3008 15.6768 9.37907L15.6846 9.43066C15.7067 9.57709 15.7278 9.71564 15.7494 9.84971C15.7867 9.87171 15.9332 9.94372 16.1898 9.89818C16.4049 9.84242 16.6391 9.71805 16.8856 9.52882C16.9617 9.47022 17.054 9.44137 17.1178 9.42743C17.2141 9.40636 17.3163 9.4038 17.4054 9.42024L17.4102 9.42097C17.661 9.45323 17.8496 9.58606 17.8905 9.75991C17.9285 9.922 17.8609 10.1915 17.3202 10.5557C17.2649 10.593 17.1929 10.6346 17.1169 10.6784C16.8122 10.8544 16.3525 11.1199 16.2798 11.5062C16.2401 11.7157 16.3177 11.9454 16.5102 12.1888C16.5123 12.1915 16.5142 12.1942 16.5164 12.197C16.5786 12.285 18.068 14.3516 20.3698 14.2341C20.4668 14.2294 20.5521 14.2986 20.5674 14.3952C20.5728 14.4299 20.572 14.4659 20.5648 14.5025C20.4983 14.851 19.8712 15.2648 18.7518 15.6979C18.6468 15.7385 18.6391 15.9252 18.6389 16.2282C18.6389 16.3534 18.6379 16.4762 18.6284 16.6071C18.6197 16.7303 18.557 16.8032 18.4366 16.8296L18.4184 16.8335C18.34 16.8506 18.2258 16.8607 18.0798 16.8637C17.8246 16.8692 17.5403 16.8846 17.1912 16.9609C16.9876 17.0055 16.7808 17.0695 16.5762 17.1511C16.1608 17.3174 15.8492 17.6593 15.5192 18.0217C15.0572 18.5291 14.5346 19.1032 13.6114 19.3048Z"
				fill="white"
			/>
			<path
				d="M10.5437 4.83846C11.1385 4.70847 13.2215 4.42157 14.657 6.3871C15.1297 7.03434 15.3287 8.3504 15.4886 9.40757C15.5141 9.5753 15.5386 9.73792 15.5635 9.89289L15.5742 9.9595L15.6285 9.99899C15.6505 10.0148 15.8532 10.1524 16.2238 10.0864L16.2298 10.0854L16.2359 10.0839C16.4768 10.0215 16.7342 9.88582 17.001 9.68087C17.0404 9.6507 17.0965 9.62791 17.1581 9.61444C17.2284 9.59909 17.3059 9.59606 17.3731 9.60868L17.3832 9.61036C17.5509 9.63123 17.6834 9.71072 17.7053 9.80405C17.7176 9.85682 17.7195 10.0563 17.2146 10.3964C17.1652 10.4297 17.0991 10.468 17.0223 10.5121C16.6876 10.7055 16.182 10.9974 16.0927 11.4706C16.0426 11.737 16.1329 12.0189 16.3613 12.308C16.4595 12.4468 17.9879 14.5472 20.3795 14.4253C20.3814 14.4363 20.3813 14.449 20.3782 14.4645C20.3591 14.5658 20.1795 14.9405 18.6835 15.5189C18.4493 15.6092 18.4489 15.8952 18.4488 16.2276C18.4485 16.3468 18.448 16.467 18.4389 16.5931C18.4359 16.6313 18.4344 16.6337 18.3962 16.642C18.3909 16.6431 18.3848 16.6445 18.3781 16.646C18.3094 16.661 18.2021 16.6694 18.0762 16.672C17.847 16.677 17.5351 16.6898 17.1509 16.7737C16.9365 16.8206 16.7197 16.8876 16.5062 16.9732C16.0496 17.156 15.7236 17.5141 15.3784 17.8934C14.9146 18.4024 14.4353 18.9291 13.5714 19.1179C13.5336 19.126 13.4965 19.1329 13.4593 19.139L13.4494 19.1408L13.4398 19.1436C13.419 19.1502 13.3979 19.1557 13.3761 19.1605C12.5122 19.3493 11.8587 19.0703 11.2269 18.8005C10.7562 18.5997 10.3116 18.4098 9.82086 18.4342C9.59148 18.4453 9.36634 18.4749 9.15206 18.5216C8.76801 18.6055 8.47993 18.7304 8.26976 18.8216C8.15412 18.8717 8.05396 18.9149 7.98553 18.9299C7.92948 18.9421 7.9277 18.939 7.90704 18.9009C7.8467 18.79 7.79594 18.678 7.74669 18.57C7.60908 18.2673 7.49038 18.0056 7.24022 18.0211C5.6405 18.1189 5.3224 17.8525 5.26317 17.7687C5.25389 17.7554 5.24846 17.7437 5.24545 17.7328C7.47179 16.8458 7.9955 14.2969 8.02769 14.1291C8.11652 13.7709 8.08247 13.4769 7.92644 13.2551C7.65012 12.8621 7.06963 12.8072 6.68563 12.7711C6.59736 12.7629 6.52132 12.7556 6.46266 12.7459C5.95613 12.6625 5.77231 12.5072 5.76918 12.3893C5.76571 12.2535 5.96197 12.0716 6.15826 12.0287C6.20237 12.0191 6.2426 12.0178 6.2741 12.025C6.62537 12.1056 6.93284 12.1182 7.18809 12.0624C7.58934 11.9747 7.72737 11.7479 7.74192 11.7223L7.77485 11.6639L7.75718 11.5991C7.71601 11.4478 7.67137 11.2896 7.62515 11.1268C7.33465 10.0979 6.97289 8.8183 7.13578 8.03213C7.62899 5.6535 9.63116 5.04094 10.2329 4.90946C10.2477 4.90621 10.5087 4.84636 10.5087 4.84636C10.5194 4.84395 10.5312 4.84118 10.5437 4.83846ZM10.4629 4.4644C10.4492 4.4674 10.4356 4.47037 10.4234 4.4732C10.3258 4.49557 10.1654 4.53227 10.151 4.53559C9.79852 4.61261 9.10406 4.81681 8.41914 5.31865C8.02752 5.60547 7.69404 5.95043 7.42803 6.34398C7.11081 6.81292 6.88688 7.3546 6.76267 7.95409C6.58071 8.83188 6.95615 10.1614 7.2578 11.2298L7.25842 11.2314C7.29073 11.3459 7.32451 11.4653 7.35696 11.5819C7.31009 11.6173 7.23118 11.6611 7.10678 11.6883C6.90663 11.732 6.65472 11.7197 6.35824 11.6517C6.27106 11.6319 6.17664 11.6329 6.07694 11.6547C5.91673 11.6897 5.7581 11.774 5.63032 11.8926C5.46952 12.0418 5.38367 12.2216 5.38817 12.3992C5.39123 12.5167 5.44043 12.7395 5.73557 12.9118C5.89793 13.0066 6.12173 13.078 6.40065 13.1239C6.47382 13.1359 6.55932 13.144 6.64988 13.1524C6.96421 13.1822 7.43988 13.2269 7.61527 13.4763C7.70416 13.6028 7.71843 13.7914 7.65778 14.0368C7.65624 14.0433 7.65468 14.0498 7.65343 14.0566C7.64008 14.1263 7.5116 14.7579 7.12397 15.4792C6.90376 15.8893 6.64136 16.2492 6.34466 16.5488C5.98253 16.9147 5.56535 17.1934 5.10482 17.3769C4.92393 17.4489 4.8263 17.6463 4.87802 17.8349C4.89312 17.8893 4.91781 17.9413 4.95155 17.9895V17.9895C5.06595 18.1515 5.27525 18.2654 5.59 18.3366C5.97457 18.4234 6.52667 18.4466 7.23078 18.4051C7.2794 18.4635 7.35085 18.6211 7.40004 18.7288C7.45192 18.8435 7.50565 18.9613 7.57252 19.0845C7.64481 19.2177 7.78926 19.3644 8.06592 19.3039C8.17077 19.2811 8.28621 19.2309 8.41994 19.1732C8.6157 19.0882 8.88342 18.972 9.23241 18.8958C9.42591 18.8535 9.63013 18.8268 9.83926 18.8164C10.2424 18.7965 10.6293 18.9615 11.077 19.1527C11.7323 19.4324 12.474 19.749 13.4564 19.5343C13.4832 19.5284 13.5099 19.5218 13.5361 19.5141C13.5688 19.5086 13.6093 19.5009 13.6517 19.4917C14.6344 19.277 15.1785 18.6792 15.6587 18.1516C15.9873 17.7912 16.2716 17.479 16.6465 17.3289C16.841 17.2511 17.0378 17.19 17.2314 17.1478C17.5647 17.0749 17.8379 17.0599 18.0836 17.0548C18.2441 17.0516 18.3668 17.0401 18.4585 17.02L18.4675 17.0183L18.4768 17.0162C18.6792 16.9721 18.8036 16.8278 18.8183 16.62C18.8282 16.483 18.829 16.3564 18.829 16.2282C18.8292 16.117 18.8294 15.9388 18.8494 15.8647C19.5075 15.6082 20.0002 15.3572 20.3143 15.1177C20.5708 14.9223 20.7137 14.7326 20.7516 14.5382C20.763 14.4799 20.7645 14.4219 20.7553 14.3649C20.7248 14.1719 20.5543 14.0328 20.3599 14.0429C18.1612 14.1549 16.7311 12.1702 16.6713 12.0857C16.6674 12.0801 16.6632 12.0746 16.659 12.0694C16.5026 11.8715 16.438 11.6939 16.4667 11.5416C16.5232 11.2418 16.9372 11.0026 17.2112 10.8444C17.2906 10.7988 17.3652 10.7556 17.4264 10.7144C17.6912 10.5361 17.8712 10.366 17.9772 10.1944C18.1038 9.98979 18.1005 9.82095 18.0758 9.71543C18.0154 9.46017 17.7713 9.27496 17.4373 9.23115C17.3232 9.21048 17.1989 9.2136 17.0773 9.24017C16.9945 9.25826 16.8745 9.29645 16.7702 9.37627C16.5471 9.54742 16.3385 9.65992 16.1495 9.71076C16.0468 9.72778 15.9708 9.72121 15.9202 9.71013C15.9043 9.60888 15.8886 9.50475 15.8721 9.3962L15.8649 9.34974C15.6987 8.25097 15.4919 6.88355 14.9638 6.16031C14.602 5.66497 14.1733 5.26466 13.6895 4.96988C13.2837 4.72293 12.8366 4.54857 12.3605 4.45154C11.5319 4.28302 10.8159 4.38727 10.4629 4.4644Z"
				fill="#020202"
			/>
			<path
				d="M34.171 1.51855L20.6491 0.732336C18.4087 0.602071 16.4875 2.32309 16.358 4.57634L15.5762 18.1759C15.4467 20.4292 17.1579 22.3614 19.3983 22.4916L32.9202 23.2779C35.1606 23.4081 37.0818 21.6871 37.2113 19.4339L37.993 5.83429C38.1225 3.58104 36.4114 1.64882 34.171 1.51855Z"
				fill="black"
			/>
			<path
				d="M30.5528 9.66749C31.5949 10.4816 32.8989 11.0007 34.3348 11.0842L34.4885 8.40945C34.2168 8.3937 33.9473 8.35051 33.6845 8.28053L33.5636 10.3859C32.1279 10.3025 30.8239 9.78331 29.7815 8.96928L29.4679 14.4277C29.3109 17.1583 26.897 19.2387 24.0765 19.0747C23.0241 19.0135 22.0636 18.6487 21.2814 18.0731C22.156 19.0451 23.4166 19.6897 24.8476 19.7729C27.6682 19.9369 30.0822 17.8564 30.2391 15.1258L30.5528 9.66749ZM31.7054 7.02699C31.1845 6.4082 30.864 5.62902 30.8334 4.78643L30.8532 4.4424L30.0868 4.39785C30.2185 5.47418 30.8241 6.42238 31.7054 7.02699ZM23.1858 16.0816C22.8985 15.6702 22.7587 15.1794 22.788 14.6847C22.8598 13.4358 23.9638 12.484 25.2542 12.5591C25.4947 12.573 25.7316 12.6225 25.9567 12.7062L26.114 9.97173C25.8482 9.92064 25.5787 9.88984 25.3082 9.87965L25.1859 12.0081C24.9607 11.9243 24.7235 11.8747 24.4829 11.8609C23.1926 11.7859 22.0885 12.7376 22.0168 13.9866C21.966 14.8697 22.4449 15.6647 23.1858 16.0816Z"
				fill="#FF004F"
			/>
			<path
				d="M29.7815 8.96928C30.8239 9.78331 32.1279 10.3025 33.5636 10.3859L33.6845 8.28053C32.8926 8.06867 32.2064 7.62193 31.7054 7.02699C30.8241 6.42238 30.2185 5.47418 30.0868 4.39785L28.0738 4.28083L27.4599 14.964C27.3836 16.2092 26.2816 17.1571 24.9939 17.0821C24.2353 17.038 23.5814 16.6487 23.1858 16.0816C22.4449 15.6647 21.966 14.8697 22.0168 13.9866C22.0885 12.7376 23.1926 11.7859 24.4829 11.8609C24.7301 11.8753 24.9663 11.9264 25.1859 12.0081L25.3082 9.87965C22.534 9.77395 20.1794 11.8362 20.0245 14.5318C19.9471 15.8774 20.4319 17.1294 21.2814 18.0731C22.0636 18.6487 23.0241 19.0135 24.0765 19.0747C26.897 19.2387 29.3109 17.1583 29.4679 14.4277L29.7815 8.96928Z"
				fill="white"
			/>
			<path
				d="M33.6845 8.28053L33.7172 7.71116C32.9945 7.6702 32.2973 7.43315 31.7054 7.02699C32.2151 7.63381 32.9071 8.07204 33.6845 8.28053ZM30.0868 4.39785C30.0742 4.29502 30.0659 4.19171 30.062 4.08825L30.0817 3.74422L27.3025 3.58263L26.6884 14.266C26.6124 15.5111 25.5105 16.4588 24.2228 16.3838C23.8448 16.3619 23.493 16.2543 23.1858 16.0816C23.5814 16.6487 24.2353 17.038 24.9939 17.0821C26.2816 17.1571 27.3836 16.2092 27.4599 14.964L28.0738 4.28083L30.0868 4.39785ZM25.3082 9.87965L25.3429 9.27363C25.1125 9.2294 24.8793 9.20037 24.6448 9.18684C21.8241 9.02283 19.4102 11.1033 19.2532 13.8337C19.1548 15.5455 19.9668 17.1062 21.2814 18.0731C20.4319 17.1294 19.9471 15.8774 20.0245 14.5318C20.1794 11.8362 22.534 9.77395 25.3082 9.87965Z"
				fill="#00F2EA"
			/>
		</svg>
	);
}

export function OcTextWidthIcon({
	className = "",
	size = 32,
}: IconProps) {
	return (
		<svg
			width={Math.round((size * 17) / 24)}
			height={size}
			className={className}
			viewBox="0 0 17 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Text width</title>
			<path
				d="M3.75 17.17C3.14316 17.7599 0.75 19.3297 0.75 20.17C0.75 21.0103 3.14316 22.5802 3.75 23.17M12.75 17.25C13.3568 17.8398 15.75 19.4097 15.75 20.25C15.75 21.0903 13.3568 22.6602 12.75 23.25M1.17285 20.1495L7.85685 20.1895L15.618 20.2295M8.25 0.75V15.75M8.25 0.75C9.6374 0.75 11.4195 0.78054 12.8384 0.92648C13.4385 0.98819 13.7386 1.01905 14.0041 1.1279C14.5566 1.35428 15.0018 1.85062 15.1694 2.4268C15.25 2.70381 15.25 3.01991 15.25 3.65214M8.25 0.75C6.8626 0.75 5.08047 0.78054 3.66161 0.92648C3.0615 0.98819 2.76144 1.01905 2.49586 1.1279C1.94344 1.35428 1.49816 1.85062 1.33057 2.4268C1.25 2.70381 1.25 3.01991 1.25 3.65214"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function OcTextHeightIcon({
	className = "",
	size = 32,
}: IconProps) {
	return (
		<svg
			width={Math.round((size * 20) / 23)}
			height={size}
			className={className}
			viewBox="0 0 20 23"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Text height</title>
			<path
				d="M12.67 18.9194C13.2599 19.5262 14.8297 21.9194 15.67 21.9194C16.5103 21.9194 18.0802 19.5262 18.67 18.9194M12.75 10.9965C13.3398 10.3897 14.9097 7.99653 15.75 7.99653C16.5903 7.99653 18.1602 10.3897 18.75 10.9965M15.6495 21.4965L15.7295 8.12853M7.75 0.75V21.75M7.75 0.75C9.1374 0.75 11.9195 0.78054 13.3384 0.92648C13.9385 0.98819 14.2386 1.01905 14.5041 1.1279C15.0566 1.35428 15.5018 1.85062 15.6694 2.4268C15.75 2.70381 15.75 3.01991 15.75 3.65214M7.75 0.75C6.3626 0.75 4.58047 0.78054 3.16161 0.92648C2.5615 0.98819 2.26144 1.01905 1.99586 1.1279C1.44344 1.35428 0.99816 1.85062 0.83057 2.4268C0.75 2.70381 0.75 3.01991 0.75 3.65214"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function OcFontIcon({
	className = "",
	size = 32,
	}: IconProps) {
	return (
		<svg
			width={size}
			height={Math.round((size * 24) / 18)}
			className={className}
			viewBox="0 0 18 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Font</title>
			<path
				d="M16.4094 3.80541C16.0122 3.80541 15.8136 3.51231 15.6889 3.09844C15.267 1.53634 14.7188 1.07415 14.397 1.07415C14.0737 1.07415 13.5763 1.66034 13.0297 2.87942C12.3075 4.41576 11.8233 6.08898 11.3752 7.69939L14.2181 7.69617C14.3921 8.03758 14.251 8.74455 13.8275 8.93941H11.0173C10.0981 11.9638 9.32336 14.8786 8.40416 17.7323C7.88218 19.3427 7.31096 20.879 6.58873 21.8533C5.79263 22.95 4.30221 24 2.5114 24C1.24421 24 0 23.4154 0 22.1223C0 21.3171 0.845339 20.5618 1.51669 20.5618C1.80558 20.5505 2.07642 20.7019 2.21266 20.9515C2.83476 22.0482 3.4306 22.6827 3.70472 22.6827C3.97884 22.6827 4.20208 22.3171 4.65019 20.7325L7.91337 8.94102L5.56611 8.9378C5.39212 8.42568 5.63998 7.81212 5.93708 7.68973H8.27448C8.7226 6.27578 9.2495 4.82963 9.99471 3.53647C11.1125 1.5621 12.9033 0 15.3639 0C17.2285 0 18 0.879286 18 2.00013C17.9754 3.19667 16.9068 3.80541 16.4094 3.80541Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export function OcShapesIcon({
	className = "",
	size = 32,
	strokeWidth = 1.5,
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
			className={className}
		>
			<title>Shapes</title>
			<defs>
				<clipPath id="clip" clipPathUnits="userSpaceOnUse">
					<path d="M0 0H24V24H0ZM8 8H24V24H8Z" clipRule="evenodd" />
				</clipPath>
			</defs>
			<circle
				cx="8.5"
				cy="8.5"
				r="7.75"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				clipPath="url(#clip)"
			/>
			<rect
				x="8.75"
				y="8.75"
				width="14.5"
				height="14.5"
				stroke="currentColor"
				strokeWidth={strokeWidth}
			/>
		</svg>
	);
}

export function OcMirrorIcon({
	className = "",
	size = 32,
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
			className={className}
		>
			<title>Mirror</title>
			<g clipPath="url(#clip0_5_41)">
				<path
					d="M12 23.2242C5.8043 23.2242 0.7817 18.2016 0.7817 12.0059C0.7817 5.81026 5.8043 0.787682 12 0.787682C18.1957 0.787682 23.2183 5.81026 23.2183 12.0059C23.2183 18.2016 18.1957 23.2242 12 23.2242Z"
					stroke="black"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12 0.787682C14.9752 0.787682 17.8287 1.9696 19.9325 4.07343C22.0363 6.17726 23.2182 9.03067 23.2182 12.0059C23.2182 14.9812 22.0363 17.8346 19.9325 19.9384C17.8287 22.0423 14.9752 23.2242 12 23.2242V0.787682Z"
					fill="black"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_41">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function OcSquarePlusIcon({
	className = "",
	size = 32,
	strokeWidth = 1.5,
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
			className={className}
		>
			<title>Square Plus</title>
			<defs>
				<mask id="frameMask" maskUnits="userSpaceOnUse">
					<rect width="24" height="24" fill="white" />
					<rect x="14.636" y="14.636" width="9.364" height="9.364" fill="black" />
				</mask>
				<clipPath id="plusClip" clipPathUnits="userSpaceOnUse">
					<rect x="16" y="16" width="9" height="8" />
				</clipPath>
			</defs>
			<rect
				x="0.923"
				y="0.923"
				width="22.154"
				height="22.154"
				rx="2.769"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				mask="url(#frameMask)"
			/>
			<rect
				x="19.493"
				y="16.486"
				width="1.503"
				height="7.514"
				fill="currentColor"
				clipPath="url(#plusClip)"
			/>
			<rect
				x="16.487"
				y="19.492"
				width="7.514"
				height="1.503"
				fill="currentColor"
				clipPath="url(#plusClip)"
			/>
		</svg>
	);
}

export function OcRippleIcon({
	className = "",
	size = 24,
	strokeWidth = 1.5,
}: IconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
			className={className}
		>
			<title>Ripple</title>
			<path
				d="M5 9C4.39316 9.58984 2 11.1597 2 12C2 12.8403 4.39316 14.4102 5 15"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19 9C19.6068 9.58984 22 11.1597 22 12C22 12.8403 19.6068 14.4102 19 15"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.42285 11.9795H21.868"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.1454 21.7021L12.1454 2.25692"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

